import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BasicInputTypeEnum } from '../../enums/basic-input-type.enum';
import { BaseComponent } from '../../abstracts/base.abstract';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-basic-search',
    templateUrl: './basic-search.component.html',
    styleUrls: ['./basic-search.component.scss'],
})
export class BasicSearchComponent extends BaseComponent implements OnInit {
    @Output() public search = new EventEmitter<string>();

    public searchForm: FormGroup;
    public basicInputTypeEnum = BasicInputTypeEnum;

    constructor(private fb: FormBuilder) {
        super();
    }

    ngOnInit(): void {
        this.searchForm = this.fb.group({
            searchValue: [''],
        });

        this.uns = this.searchValue.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((value: string) => {
            this.search.emit(value);
        });
    }

    public resetSearch(): void {
        this.searchForm.reset();
    }

    public get searchValue(): FormControl {
        return this.searchForm.get('searchValue') as FormControl;
    }
}
